import SourceType from "@ext/storage/logic/SourceDataProvider/model/SourceType";

const importSourceTypes = [
	SourceType.confluenceCloud,
	SourceType.confluenceServer,
	SourceType.notion,
];

export default importSourceTypes;
